<template>
  <div class="container-fluid py-4">
    <div class="row justify-content-center">
      <div class="col-lg-8 col-md-10">
        <div class="card">
          <div class="card-body p-4">
            <h3 class="mb-4">Test Email Pages</h3>
            <p class="mb-4">Click the links below to test the email response pages:</p>
            
            <div class="d-flex flex-column gap-3">
              <h5 class="mb-3">Assignment Pages</h5>
              <router-link 
                to="/Account/declineassignment/test-token/test-uid" 
                class="btn btn-danger"
              >
                Test Decline Assignment Page
              </router-link>
              
              <router-link 
                to="/Account/assignmentconfirmation/test-token/test-uid" 
                class="btn btn-success"
              >
                Test Assignment Confirmation Page
              </router-link>
              
              <router-link 
                to="/Account/emailresponse/test-token/test-uid" 
                class="btn btn-secondary"
              >
                Test Email Response Page
              </router-link>
              
              <h5 class="mb-3 mt-4">Swap Pages</h5>
              <router-link 
                to="/Account/swapemailrequest/test-token/test-uid" 
                class="btn btn-primary"
              >
                Test Swap Email Request Page
              </router-link>
              
              <router-link 
                to="/Account/swapemailresponse/test-token/test-uid" 
                class="btn btn-info"
              >
                Test Swap Email Response Page
              </router-link>
              
              <h5 class="mb-3 mt-4">Volunteer Pages</h5>
              <router-link 
                to="/Account/volunteerinvitation/test-token/test-uid" 
                class="btn btn-warning"
              >
                Test Volunteer Invitation Page
              </router-link>
              
              <router-link 
                to="/Account/volunteersignupconfirmation/test-token/test-uid" 
                class="btn btn-success"
              >
                Test Volunteer Signup Confirmation Page
              </router-link>
              
              <h5 class="mb-3 mt-4">Swap Selection</h5>
              <router-link 
                to="/Account/selectswap/test-token/test-uid" 
                class="btn btn-dark"
              >
                Test Select Swap Page
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TestEmailPages'
}
</script>

